/* Goal Station front-end behaviour. No dependencies. */
(function(){
  document.documentElement.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };

  /* ---------- nav ---------- */
  function initNav(){
    var nav = $('.nav'); if(!nav) return;
    var drawer = $('.drawer');
    var bar = $('.mobile-bar');
    var onScroll = function(){
      nav.classList.toggle('is-scrolled', window.scrollY > 24);
      if(bar) bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.7);
    };
    var ticking = false;
    window.addEventListener('scroll', function(){ if(!ticking){ requestAnimationFrame(function(){ onScroll(); ticking=false; }); ticking=true; } }, {passive:true});
    onScroll();
    // mega menus
    $$('.nav__item[data-menu]').forEach(function(item){
      var btn = $('button', item);
      var open = function(){ closeAll(); item.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); };
      var close = function(){ item.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); };
      item._close = close;
      var canHover = window.matchMedia('(hover:hover)').matches;
      btn.addEventListener('click', function(e){ e.stopPropagation(); if(item.classList.contains('is-open') && !canHover){ close(); } else { open(); } });
      if(window.matchMedia('(hover:hover)').matches){
        var t; item.addEventListener('mouseenter', function(){ clearTimeout(t); open(); });
        item.addEventListener('mouseleave', function(){ t = setTimeout(close, 120); });
      }
    });
    function closeAll(){ $$('.nav__item[data-menu]').forEach(function(i){ i._close && i._close(); }); }
    document.addEventListener('click', closeAll);
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeAll(); setDrawer(false); } });
    var burger = $('.nav__burger');
    function setDrawer(v){ nav.classList.toggle('is-open', v); if(drawer) drawer.classList.toggle('is-open', v); document.body.style.overflow = v ? 'hidden' : ''; burger && burger.setAttribute('aria-expanded', v?'true':'false'); }
    if(burger) burger.addEventListener('click', function(){ setDrawer(!nav.classList.contains('is-open')); });
    if(drawer) $$('a', drawer).forEach(function(a){ a.addEventListener('click', function(){ setDrawer(false); }); });
  }

  /* ---------- reveals ---------- */
  function initReveal(){
    var els = $$('.rv, .rv-clip');
    if(!('IntersectionObserver' in window) || reduce){ els.forEach(function(e){ e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -10% 0px', threshold:0.08});
    els.forEach(function(e){ io.observe(e); });
    $$('[data-stagger]').forEach(function(g){ $$(':scope > *', g).forEach(function(c,i){ c.style.setProperty('--i', i); }); });
  }

  /* ---------- counters ---------- */
  function initCounters(){
    var els = $$('[data-count]');
    if(!els.length) return;
    var run = function(el){
      var target = parseFloat(el.getAttribute('data-count'));
      var dec = (el.getAttribute('data-count').split('.')[1]||'').length;
      var start = performance.now(), dur = reduce ? 0 : 900;
      var fmt = function(v){ return v.toLocaleString('en-GB', {minimumFractionDigits:dec, maximumFractionDigits:dec}); };
      var tick = function(now){
        var p = dur ? Math.min(1,(now-start)/dur) : 1; p = 1 - Math.pow(1-p, 3);
        el.textContent = fmt(target*p);
        if(p<1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    if(!('IntersectionObserver' in window) || reduce){ return; }
    els.forEach(function(e){ e.textContent = '0'; });
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ run(en.target); io.unobserve(en.target); } }); }, {threshold:0.2});
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------- chapters nav ---------- */
  function initChapters(){
    $$('.chapters').forEach(function(sec){
      var links = $$('.chapters__nav a', sec), steps = $$('.chapter', sec);
      if(!links.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ var i = steps.indexOf(en.target); links.forEach(function(l,j){ l.classList.toggle('is-active', i===j); }); } });
      }, {rootMargin:'-40% 0px -50% 0px'});
      steps.forEach(function(s){ io.observe(s); });
      links.forEach(function(l,i){ l.addEventListener('click', function(e){ e.preventDefault(); steps[i].scrollIntoView({behavior: reduce?'auto':'smooth', block:'center'}); }); });
    });
  }

  /* ---------- gallery ---------- */
  function initGallery(){
    $$('[data-gallery]').forEach(function(wrap){
      var track = $('.gallery', wrap);
      $$('[data-dir]', wrap).forEach(function(b){ b.addEventListener('click', function(){ var w = track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 14 : 400; track.scrollBy({left: (b.getAttribute('data-dir')==='next'?1:-1)*w, behavior: reduce?'auto':'smooth'}); }); });
    });
  }

  /* ---------- video ---------- */
  function initVideo(){
    var vids = $$('video[autoplay]');
    if(!vids.length) return;
    if(reduce){ vids.forEach(function(v){ v.removeAttribute('autoplay'); v.pause(); }); return; }
    if(!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ var v = en.target; if(en.isIntersecting){ v.play && v.play().catch(function(){}); } else { v.pause(); } }); }, {threshold:0.15});
    vids.forEach(function(v){ io.observe(v); });
  }

  /* ---------- form ---------- */
  function initForm(){
    $$('form.form').forEach(function(f){
      f.addEventListener('submit', function(e){
        e.preventDefault();
        var ok = true;
        $$('.field', f).forEach(function(fd){
          var inp = $('input,select,textarea', fd); if(!inp) return;
          var bad = inp.required && (!inp.value.trim() || (inp.type==='email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(inp.value)));
          fd.classList.toggle('is-invalid', bad); if(bad) ok = false;
        });
        if(!ok){ var first = $('.is-invalid input, .is-invalid select', f); first && first.focus(); return; }
        var btn = $('button[type=submit]', f); btn.disabled = true; btn.textContent = 'Sending';
        // Production: POST to HubSpot Forms API (portal 25718159, form 4bf1f65c-223c-4d15-b8af-d129d4ab6104). Preview: simulate.
        var payload = { fields: $$('input,select,textarea', f).map(function(i){ return {name:i.name, value:i.value}; }) };
        var endpoint = f.getAttribute('data-endpoint');
        var done = function(){ f.classList.add('is-sent'); btn.textContent = 'Sent'; };
        if(endpoint){ fetch(endpoint, {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload)}).then(done).catch(done); } else { setTimeout(done, 700); }
      });
      $$('input,select,textarea', f).forEach(function(i){ i.addEventListener('input', function(){ i.closest('.field').classList.remove('is-invalid'); }); });
    });
  }

  /* ---------- document pages: table of contents from h2 ---------- */
  function initDoc(){
    $$('.doc').forEach(function(doc){
      var prose = $('.prose', doc), toc = $('.doc__toc', doc); if(!prose || !toc) return;
      var hs = $$('h2', prose); if(hs.length < 2){ toc.hidden = true; doc.classList.add('doc--no-toc'); return; }
      var ol = $('ol', toc); ol.innerHTML = '';
      hs.forEach(function(h,i){ if(!h.id) h.id = 'section-' + (i+1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,40); var li = document.createElement('li'); var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent.trim(); li.appendChild(a); ol.appendChild(li); });
      var links = $$('a', ol);
      if('IntersectionObserver' in window){ var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ var i = hs.indexOf(en.target); links.forEach(function(l,j){ l.classList.toggle('is-active', i===j); }); } }); }, {rootMargin:'-20% 0px -70% 0px'}); hs.forEach(function(h){ io.observe(h); }); }
      if(window.matchMedia('(max-width:900px)').matches) toc.removeAttribute('open');
    });
  }

  /* ---------- word split for hero ---------- */
  function splitWords(){
    $$('[data-words]').forEach(function(h){
      if(h.getAttribute('data-split')) return;
      h.setAttribute('data-split','1');
      var html = h.innerHTML;
      // keep inline tags (em, span.accent) intact by splitting on spaces outside tags
      var parts = html.split(/(\s+)/);
      var out = '', i = 0;
      parts.forEach(function(p){ if(!p.trim()){ out += p; return; } out += '<span class="w"><span style="transition-delay:'+(i*55)+'ms">'+p+'</span></span>'; i++; });
      h.innerHTML = out;
    });
  }

  function boot(){
    splitWords();
    initNav(); initReveal(); initCounters(); initChapters(); initGallery(); initVideo(); initForm(); initDoc();
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ document.documentElement.classList.add('is-loaded'); }); });
  }
  window.GS = { boot: boot, reinit: function(){ document.documentElement.classList.remove('is-loaded'); splitWords(); initReveal(); initCounters(); initChapters(); initGallery(); initVideo(); initForm(); window.scrollTo(0,0); requestAnimationFrame(function(){ requestAnimationFrame(function(){ document.documentElement.classList.add('is-loaded'); }); }); } };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
